export default __webpack_public_path__ + "278e4715a0fdbda7b6d3dad495faba50.svg";